import { render, staticRenderFns } from "./my-presentation.vue?vue&type=template&id=efd87134&scoped=true&"
import script from "./my-presentation.vue?vue&type=script&lang=js&"
export * from "./my-presentation.vue?vue&type=script&lang=js&"
import style0 from "./my-presentation.vue?vue&type=style&index=0&id=efd87134&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd87134",
  null
  
)

export default component.exports